import { deleteCookies } from "../../../utils/common";

export function handleResponse(response) {
  if (response.results) {
    return response.results;
  }

  if (response.data) {
    return response.data;
  }

  return response;
}

export function handleError(error) {
  if (error.response && error.response.status === 401) {
    deleteCookies();
    // Redirect to the login page if the response status is 401 (Unauthorized)
    window.location.href = "/sign-in";
  } else {
    // Handle other error cases here
    console.error("Error:", error);
  }
  throw error;
}
